import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {BsArrowLeft} from 'react-icons/bs';
import styled from 'styled-components';

function BackArrow() {

  const [colorClass, setColorClass] = useState("");

  const changeColor = ()=>{
    if(window.scrollY>window.innerHeight){
      setColorClass("dark-color");
    }else{
      setColorClass("");
    }
  }

  useEffect(()=>{
    changeColor();
    window.addEventListener('scroll', changeColor);
  },[]);


  const navigate = useNavigate();
  const handleClick = ()=>{
    navigate(-1);//to go back (simple)
  }

  return (
    <Back>
        <BsArrowLeft onClick={handleClick} strokeWidth={0.00008}
          className={` arrow ${colorClass}`}
        />
    </Back>
  )
}

const Back  = styled.div`
    
    position: fixed;
    top: 5rem;
    left: 2rem;
    padding: 0.5rem;
    cursor: pointer;
    transition: all 0.5s ease;
    z-index: 100;
    &:hover{
      transform: translate(-15%, 0%);
    }

    svg{
        font-size: 3rem;
    }

    @media only screen and (max-width: 500px){
      top: 4rem;
      left: 1.5rem;
      .arrow{
        font-size: 1.8rem;

      }
    }

`


export default BackArrow